module.exports = __webpack_public_path__ + "static/img/thum3.c0e520c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/thum3.png
// module id = d+XD
// module chunks = 1